module.exports = __webpack_public_path__ + "img/freertos-stencil.19a00e4f.svg";